import { MercureMessage, useMercure } from '@/composables/useMercure.ts'
import { type CircularBuffer, useCircularBuffer } from '@/composables/useCircularBuffer.ts'

interface ServerInfoData extends MercureMessage {
  metric: {
    cpu_usage_percent_1: number
    cpu_usage_percent_5: number
    cpu_usage_percent_15: number
    disk_free_bytes: number
    disk_free_percent: number
    disk_total_bytes: number
    memory_total_bytes: number
    memory_usage_percent: number
    memory_used_bytes: number
  }
  ts: number
}
export const ServerInfoService = new (class {
  #_buffer: CircularBuffer<ServerInfoData> = useCircularBuffer<ServerInfoData>(10)
  get items() {
    return this.#_buffer.items
  }
  push(data: ServerInfoData) {
    this.#_buffer.push(data)
  }
})()

export default {
  install() {
    useMercure().subscribe<ServerInfoData>('*', (data) => {
      if (data['@context'] != 'server-info') return
      ServerInfoService.push(data)
    })
  }
}
// export const MetricService = new _MetricService()
